import { getCookie, setCookie } from '@pb/utils'

import OPTIMIZELY from 'constants/optimizely'
import clubCardActions from 'features/account/club-card/duck/actions'
import {
  normalizeCustomerCodeState,
  normalizeClubCardState,
} from 'features/account/club-card/duck/normalize'

import requests from '../requests'
import actions from './actions'
import { normalizeUserData } from './normalize'
import selectors from './selectors'

export const operationSetScreenType = (screenType) => (dispatch) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
  dispatch(actions.setScreenType(screenType))
}

export const operationFetchSettings = () => (dispatch) => {
  dispatch(actions.fetchSettingsStart())

  return requests
    .fetchSettings()
    .then((data) => {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      dispatch(actions.fetchSettingsSuccess(data))
    })
    .catch((error) => {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      dispatch(actions.fetchSettingsFail(error))
    })
}

export const operationFetchConfig =
  (locale = 'en_gb') =>
  (dispatch) => {
    dispatch(actions.fetchConfigStart())

    return requests
      .fetchConfig(locale)
      .then((data) => {
        dispatch(actions.fetchConfigSuccess(data))
      })
      .catch((error) => {
        dispatch(actions.fetchConfigFail(error))
      })
  }

export const operationToggleLoaders = () => (dispatch) => {
  dispatch(actions.toggleLoaders())
}

export const operationResetXhrErrorCodes = () => (dispatch) => {
  dispatch(actions.resetXhrErrorCode())
}

export const operationFetchUser = () => (dispatch, getState) => {
  dispatch(actions.fetchUserStart())

  return requests
    .fetchUser()
    .then((data) => {
      const userNormalizedData = normalizeUserData(data)

      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      dispatch(actions.fetchUserSuccess(userNormalizedData))

      const isFullMember = selectors.getUserIsFullMember(getState())
      const userWasAlreadyPresentInTest = getCookie('WelcomeOfferABCookie') || ''

      if (isFullMember) {
        // TODO: move this logic into features/account
        const clubCardState = normalizeClubCardState(data)
        dispatch(clubCardActions.setClubCardPropsToState(clubCardState))
        const customerCodeState = normalizeCustomerCodeState(data)
        dispatch(clubCardActions.setCustomerCodeState(customerCodeState))
      }
      if (!userWasAlreadyPresentInTest) {
        setCookie('WelcomeOfferABCookie', OPTIMIZELY.LCA_FASHION_WELCOME_OFFER_LOGIN_BANNER, 24)
      }
    })
    .catch((error) => {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
      dispatch(actions.fetchUserFail(error))
    })
}

export const operationSetPreviousFNSubscribeState = (previousFNSubscribeState) => (dispatch) => {
  dispatch(actions.setPreviousFNSubscribeState(previousFNSubscribeState))
}

export const operationSetIsSendAgainClicked =
  (isSendAgainClickedForCurrentSession) => (dispatch) => {
    dispatch(actions.setIsSendAgainClicked(isSendAgainClickedForCurrentSession))
  }

export const operationSetSendAgainAlreadyClicked =
  (isSendAgainClickedForCurrentSession) => (dispatch) => {
    dispatch(actions.setIsSendAgainAlreadyClicked(isSendAgainClickedForCurrentSession))
  }

export const operationSetIsChallengesBannerTrackingSent =
  (setIsChallengesBannerTrackingSent) => (dispatch) => {
    dispatch(actions.setIsChallengesBannerTrackingSent(setIsChallengesBannerTrackingSent))
  }
